module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGcf7b2e43cd8aa203edf244e44330f90e.cf7b2e43.png";